<template>
    <div class="trade">
        <navs></navs>
        <!--北斗-->
        <div class="tradeBox">
            <p class="starTitle">采购贸易</p>
            <p class="beiIntro">平台运用物流大数据、云计算等互联网技术，整合资源，优化资源配置，为建安、房地产、钢铁等行业的大宗物资采购、贸易、租赁、维修等集采项目，提供供应链信息、供应链集采、供应链结算、供应链金融等供应链服务，并为平台入驻商户提供财税服务，使上下游客户共享地区洼地政策红利，降低采购交易成本，助力产业降本增效</p>
            <div class="starsImg"></div>
        </div>
        <div class="supplyInfo">
           <div class="titles">供应链信息</div>
           <p class="collectSub">
               传统采购信息化程度、信息不对称，平台为供需双方提供信息服务，基于好洼地小程序，供应链各方可以随时通过平台发布及查询各类供求信息，快速进行业务对接
           </p>
            <div class="collectImg"></div>
        </div>
          <!--数据采集-->
        <div class="collection">
           <div class="titles">供应链集采</div>
           <p class="collectSub">
               平台汇聚多方供应商信息资源，运用平台聚合优势，为各企业提供集中采购服务。一端汇总需求，平台通过集中下单，提高议价能力，降低采购成本；另一端，稳定输出订单，大幅减少供应方的产能闲置浪费，降低生产成本
             </p>
            <div class="collectImg"></div>
        </div>
        <!---->
         <div class="supplyInfo">
           <div class="titles">供应链结算</div>
           <p class="collectSub">
               采购交易资金结算不安全，税负高，供应商无法开票怎么办？平台以购销模式完美解决行业两大痛点——无进销及税费高等问题，同时平台作为中间商签订合同保障交易安全。平台优化实际采购交易流程，将交易全流程嵌入平台 SaaS订单管理系统，实现信息流、资金流、合同流、发票流、物流等五流合一，应用大数据分析，管理，保障交易真实性和安全性，同时让采供双方共享平台税收洼地政策，节约交易成本
           </p>
            <div class="collectImg1"></div>
        </div>
        <div style="margin-top:1rem"></div>
        <foot></foot>
       <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
export default {
    name:'trade',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    }
}
</script>
<style lang='less' rel='stylesheet/less'>
   @rem:16rem;
   @col-f:#fff;
   .tradeBox{
       width: 100%;
       height: 458/@rem;
       background: #0F133B;
       text-align: center;
        // text-align:justify;
        // text-align-last: center;
       .starTitle{
           padding-top: 30/@rem;
            font-size: 18/@rem;
             text-align: center;
             color:  @col-f;
            font-weight: 300;
       }
       .beiIntro{
           font-size: 10/@rem;
            color:  @col-f;
            padding-left: 19/@rem;
            padding-right:19/@rem;
            font-weight: 300;
         text-align: left;
            line-height: 20/@rem
       }
       .starsImg{
           width: 100%;
           height: 228/@rem;
            background: url('../assets/cai-b.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 290/@rem 200/@rem;
       }
   }
  .titles{
       font-size: 18/@rem;
       text-align: center;
       color:  #333;
    //    font-weight: 300;
  }
 .supplyInfo{
       padding: 22/@rem 16/@rem;

      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //   text-align: justify;
        //   text-align-last: center;
          text-align: center;
          line-height: 16/@rem;
      }
      .collectImg{
            width: 100%;
            height: 188/@rem;
            background: url('../assets/cai-phone.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 128/@rem 168/@rem;
      }
      .collectImg1{
            width: 100%;
            height: 148/@rem;
            background: url('../assets/cai-2.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 268/@rem 128/@rem;
      }
  }
  .collection{
       padding: 22/@rem 16/@rem;
      background: #F8F9FA;
      .collectSub{
          font-size: 10/@rem;
          color: #666;
         // text-align: justify;
          text-align: center;
        line-height: 16/@rem;
      }
      .collectImg{
            width: 100%;
            height: 118/@rem;
            background: url('../assets/cai-1.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 288/@rem 90/@rem;
      }
  }


</style>



// WEBPACK FOOTER //
// src/components/trade.vue